import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { Money } from '../../type/order';
export class TranscriptVersion {
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * User who submitted this version of the transcript
     */
    )
], TranscriptVersion.prototype, "transcriberFee", void 0);
